// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Glw","col":"styles_col__1HJLD","actions":"styles_actions__22Hct","conflict":"styles_conflict__1txVa"};